import {
    resolveWorkspaceSurface,
    WORKSPACE_TAB_QUERY_KEY,
} from '@/features/workspace/navigation';

export function normalizeOfficePathname(pathname: string): string {
    return pathname.length > 1 ? pathname.replace(/\/+$/, '') || '/' : pathname;
}

/** 仅 Workspace 顶层按 Tab 拆分；子路由保留层级并移除实体 ID。 */
export function resolveRumViewName(pathname: string, search: string, onboarding = false): string {
    const path = normalizeOfficePathname(pathname);
    if (/^\/workspace\/[^/]+$/.test(path)) {
        if (onboarding) return '/workspace/?/onboarding';
        const surface = resolveWorkspaceSurface(
            new URLSearchParams(search).get(WORKSPACE_TAB_QUERY_KEY)
        );
        return `/workspace/?/${surface}`;
    }
    return path
        .replace(/^\/workspace\/[^/]+/, '/workspace/?')
        .replace(/^(\/workspace\/\?\/(?:builder|design-system))\/[^/]+/, '$1/?')
        .replace(/^\/project\/[^/]+/, '/project/?')
        .replace(/^(\/project\/\?\/session)\/[^/]+/, '$1/?')
        .replace(/^\/creator\/[^/]+/, '/creator/?');
}
